import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import IconForward from '../../audi-ui-components/icons/Forward';
import IconDiscussion from '../../audi-ui-components/icons/Discussion';
import IconSettings from '../../audi-ui-components/icons/Settings';
import IconDocuments from '../../audi-ui-components/icons/Documents';
import IconDocDollar from '../../audi-ui-components/icons/DocumentPricelistDollar';
import IconCatalogue from '../../audi-ui-components/icons/Catalogue';
import IconTestDrive from '../../audi-ui-components/icons/TestDrive';
import IconUsedCars from '../../audi-ui-components/icons/UsedCars';
import IconPoi from '../../audi-ui-components/icons/Poi';
import IconInspection from '../../audi-ui-components/icons/Inspection';
import IconCaution from '../../audi-ui-components/icons/Caution';
import IconAnnouncements from '../../audi-ui-components/icons/Announcements';
import Spinner from '../../audi-ui-components/Spinner';
import {request} from '../../functions/apiRequestHelper';
import './Home.scss';

import {
    PATH_CONTACTUS,
    PATH_PREFERENCECENTRE,
    PATH_REQUEST_TESTDRIVE,
    PATH_REQUEST_QUOTE,
    PATH_ADE_RYI,
    PATH_ADE_BROCHURE,
    PATH_ADE_WAITLIST,
    PATH_UPCOMINGMODELS,
    PATH_PRICECALCULATOR,
    PATH_STARTPRICECALCULATOR,
    PATH_SERVICE_PLAN_CALCULATOR,
    PATH_SERVICE_PRICE,
    PATH_LOCATEADEALER,
    PATH_LOCATEAREPAIRCENTRE,
    PATH_LOCATETRADEPART,
    PATH_XTIME,
    PATH_XTIME_DEALER,
    PATH_AFS_FEEDBACK,
    PATH_AFS_ENQUIRY,
    PATH_AFS_FLEET_ENQUIRY,
    PATH_AFS_CALCULATOR,
    PATH_CHANGE_VEHICLE_OWNER,
    PATH_DEALER_OFFER,
    PATH_RECALL_TAKATA,
    PATH_BUY_SERVICE_PLAN,
    PATH_TRADEIN,
    PATH_EV_RYI,
    PATH_FINANCE_PRICE_CALCULATOR,
    PATH_FINANCE_BUDGET_CALCULATOR
} from '../../constants';

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            list: null,
            promoPath: 'promotion'
        }
    }

    addThemeParam = (path, theme = 'dark') => {
        return path.includes('?') ? `${path}&theme=${theme}` : `${path}?theme=${theme}`;
    }

    componentDidMount() {
        request(process.env.RAZZLE_API_HOST, { path: "1/form" }).then(
            (data) => {
                let list = [];
                for (let i=0; i<data.length; i++) {
                    if (data[i].slug && data[i].openTitle) {
                        list.push(data[i]);
                    }
                }
                this.setState({
                    list: list,
                    loading: false
                });
            }
        ).catch(
            (error) => {
                console.error(error);
                this.setState({
                    loading: false
                });
            }
        );
    }

    render() {
        return (
            <Layout>
                <div className="audi-forms__page index">
                    <h2 className="aui-headline-3">Choose a form.</h2>

                    <ul className="form-links">

                        <li>
                            <Link to={this.addThemeParam(PATH_CONTACTUS, 'light')}>
                                <IconDiscussion large className="link-icon" />
                                <div className="link-text">Contact us</div>
                                <IconForward large className="link-arrow" />
                            </Link>
                            <Link to={this.addThemeParam(PATH_CONTACTUS)} className="dark">
                                <IconDiscussion large className="link-icon" />
                                <div className="link-text">Contact us</div>
                                <IconForward large className="link-arrow" />
                            </Link>
                        </li>

                        <li>
                            <Link to={this.addThemeParam(`${PATH_PREFERENCECENTRE}/0036F000028Cd9nQAC`, 'light')}>
                                <IconSettings large className="link-icon" />
                                <div className="link-text">Preference Centre</div>
                                <IconForward large className="link-arrow" />
                            </Link>
                            <Link to={this.addThemeParam(`${PATH_PREFERENCECENTRE}/0036F000028Cd9nQAC`)} className="dark">
                                <IconSettings large className="link-icon" />
                                <div className="link-text">Preference Centre</div>
                                <IconForward large className="link-arrow" />
                            </Link>
                        </li>

                        <li>
                            <span className="subheading">Request/RYI Forms</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_REQUEST_TESTDRIVE, 'light')}>
                                        <IconTestDrive large className="link-icon" />
                                        <div className="link-text">Request a test drive</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_REQUEST_TESTDRIVE)} className="dark">
                                        <IconTestDrive large className="link-icon" />
                                        <div className="link-text">Request a test drive</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(`${PATH_REQUEST_QUOTE}/123?carline=a1sb-2026-gb`, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Request a quote</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(`${PATH_REQUEST_QUOTE}/123?carline=a1sb-2026-gb`)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Request a quote</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_UPCOMINGMODELS, 'light')}>
                                        <IconUsedCars large className="link-icon" />
                                        <div className="link-text">RYI Upcoming Models Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_UPCOMINGMODELS)} className="dark">
                                        <IconUsedCars large className="link-icon" />
                                        <div className="link-text">RYI Upcoming Models Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_EV_RYI, 'light')}>
                                        <IconUsedCars large className="link-icon" />
                                        <div className="link-text">EV RYI Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_EV_RYI)} className="dark">
                                        <IconUsedCars large className="link-icon" />
                                        <div className="link-text">EV RYI Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_ADE_RYI, 'light')}>
                                        <IconTestDrive large className="link-icon" />
                                        <div className="link-text">Register your interest for ADE</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_ADE_RYI)} className="dark">
                                        <IconTestDrive large className="link-icon" />
                                        <div className="link-text">Register your interest for ADE</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_ADE_BROCHURE, 'light')}>
                                        <IconCatalogue large className="link-icon" />
                                        <div className="link-text">Request an ADE brochure</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_ADE_BROCHURE)} className="dark">
                                        <IconCatalogue large className="link-icon" />
                                        <div className="link-text">Request an ADE brochure</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(`${PATH_ADE_WAITLIST}/2219`, 'light')}>
                                        <IconCatalogue large className="link-icon" />
                                        <div className="link-text">ADE RYI/Waitlist</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(`${PATH_ADE_WAITLIST}/2219`)} className="dark">
                                        <IconCatalogue large className="link-icon" />
                                        <div className="link-text">ADE RYI/Waitlist</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Pricing</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_FINANCE_PRICE_CALCULATOR, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Finance Price calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_FINANCE_PRICE_CALCULATOR)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Finance Price calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_FINANCE_BUDGET_CALCULATOR, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Finance Budget calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_FINANCE_BUDGET_CALCULATOR)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Finance Budget calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_PRICECALCULATOR, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Price calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_PRICECALCULATOR)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Price calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_STARTPRICECALCULATOR, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Starting Price calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_STARTPRICECALCULATOR)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Starting Price calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_SERVICE_PLAN_CALCULATOR, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Service Price Calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_SERVICE_PLAN_CALCULATOR)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Service Price Calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_SERVICE_PRICE, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Service Price Jellybean Widget</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_SERVICE_PRICE)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Service Price Jellybean Widget</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_TRADEIN, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Trade-in</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_TRADEIN)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Trade-in</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Maps</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_LOCATEADEALER, 'light')}>
                                        <IconPoi large className="link-icon" />
                                        <div className="link-text">Find a dealer or service centre</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_LOCATEADEALER)} className="dark">
                                        <IconPoi large className="link-icon" />
                                        <div className="link-text">Find a dealer or service centre</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_LOCATEAREPAIRCENTRE, 'light')}>
                                        <IconPoi large className="link-icon" />
                                        <div className="link-text">Find an authorised repair centre</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_LOCATEAREPAIRCENTRE)} className="dark">
                                        <IconPoi large className="link-icon" />
                                        <div className="link-text">Find an authorised repair centre</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_LOCATETRADEPART, 'light')}>
                                        <IconPoi large className="link-icon" />
                                        <div className="link-text">Find a trade parts centre</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_LOCATETRADEPART)} className="dark">
                                        <IconPoi large className="link-icon" />
                                        <div className="link-text">Find a trade parts centre</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Service</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_XTIME, 'light')}>
                                        <IconInspection large className="link-icon" />
                                        <div className="link-text">Book a Service (XTime)</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_XTIME)} className="dark">
                                        <IconInspection large className="link-icon" />
                                        <div className="link-text">Book a Service (XTime)</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(`${PATH_XTIME_DEALER}/5`, 'light')}>
                                        <IconInspection large className="link-icon" />
                                        <div className="link-text">Book a Service (XTime) for IPH3</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(`${PATH_XTIME_DEALER}/5`)} className="dark">
                                        <IconInspection large className="link-icon" />
                                        <div className="link-text">Book a Service (XTime) for IPH3</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_BUY_SERVICE_PLAN, 'light')}>
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Buy a Service Plan</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_BUY_SERVICE_PLAN)} className="dark">
                                        <IconDocDollar large className="link-icon" />
                                        <div className="link-text">Buy a Service Plan</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">AFS Forms</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_AFS_FEEDBACK, 'light')}>
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS - Feedback</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_AFS_FEEDBACK)} className="dark">
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS - Feedback</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_AFS_ENQUIRY, 'light')}>
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS - Enquiry</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_AFS_ENQUIRY)} className="dark">
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS - Enquiry</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_AFS_FLEET_ENQUIRY, 'light')}>
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS - Fleet Enquiry</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_AFS_FLEET_ENQUIRY)} className="dark">
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS - Fleet Enquiry</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={this.addThemeParam(PATH_AFS_CALCULATOR, 'light')}>
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS Calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_AFS_CALCULATOR)} className="dark">
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">AFS Calculator</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Change Ownership</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_CHANGE_VEHICLE_OWNER, 'light')}>
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">Change Ownership Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_CHANGE_VEHICLE_OWNER)} className="dark">
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">Change Ownership Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Dealer Offer</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(`${PATH_DEALER_OFFER}/testing?v=1,72,204,86,166`, 'light')}>
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">Dealer Offer Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(`${PATH_DEALER_OFFER}/testing?v=1,72,204,86,166`)} className="dark">
                                        <IconDocuments large className="link-icon" />
                                        <div className="link-text">Dealer Offer Form</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Recall</span>
                            <ul>
                                <li>
                                    <Link to={this.addThemeParam(PATH_RECALL_TAKATA, 'light')}>
                                        <IconCaution large className="link-icon" />
                                        <div className="link-text">Takata Recall VIN checker</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                    <Link to={this.addThemeParam(PATH_RECALL_TAKATA)} className="dark">
                                        <IconCaution large className="link-icon" />
                                        <div className="link-text">Takata Recall VIN checker</div>
                                        <IconForward large className="link-arrow" />
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span className="subheading">Promotions</span>
                            <i>
                                The following forms are available on paths
                                <br /><span className="aui-color-gray90" style={{cursor: 'pointer'}} onClick={() => { this.setState({promoPath: 'promotion'}); }}>'/promotion/form-name'</span>,
                                <br /><span className="aui-color-gray90" style={{cursor: 'pointer'}} onClick={() => { this.setState({promoPath: 'event'}); }}>'/event/form-name'</span> and
                                <br /><span className="aui-color-gray90" style={{cursor: 'pointer'}} onClick={() => { this.setState({promoPath: 'competition'}); }}>'/competition/form-name'</span>
                            </i>
                            <ul>
                                {this.state.loading && <li><Spinner isContinuous /></li>}
                                {!this.state.loading && this.state.list && this.state.list.map((item, i) => (
                                    <li key={i}>
                                        <Link to={`/${this.state.promoPath}/${item.slug}`}>
                                            <IconAnnouncements large className="link-icon" />
                                            <div className="link-text">{item.name}</div>
                                            <IconForward large className="link-arrow" />
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </li>

                    </ul>
                </div>
            </Layout>
        );
    }
}

export default Home;
